import { render, staticRenderFns } from "./ExpensesBacklink.vue?vue&type=template&id=3dd5c22f&"
import script from "./ExpensesBacklink.vue?vue&type=script&lang=js&"
export * from "./ExpensesBacklink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports